// Libraries
import React from 'react';

// Supermove
import {Loading, Styled} from '@supermove/components';
import {useQuery} from '@supermove/hooks';
import {ViewStyleProp} from '@supermove/styles/types';

// App
import ErrorState from '@shared/design/components/EmptyState/ErrorState';
import ErrorCatcher from '@shared/modules/Error/components/ErrorCatcher';

const ErrorStateContainer = Styled.View`
  padding: 24px;
`;

const BlockWrapper = Styled.View`
  z-index: ${({index}: {index: number}) => 100 - index};
  padding: 16px;
`;

interface ProjectDetailsBlockWrapperProps {
  index: number;
  query: any;
  queryVariables: any;
  SkeletonComponent?: React.FC;
  style?: ViewStyleProp;
  children: ({data, refetch}: {data: any; refetch: () => void}) => React.ReactNode;
}

const ProjectDetailsBlockWrapper = ({
  index,
  query,
  queryVariables,
  SkeletonComponent,
  style,
  children,
}: ProjectDetailsBlockWrapperProps) => {
  const {data, loading, refetch} = useQuery(query, {
    fetchPolicy: 'cache-and-network',
    variables: queryVariables,
  });

  return (
    <ErrorCatcher
      ErrorComponent={() => (
        <ErrorStateContainer>
          <ErrorState />
        </ErrorStateContainer>
      )}
    >
      <Loading
        loading={loading}
        as={() => (
          <BlockWrapper index={index} style={style}>
            {SkeletonComponent && <SkeletonComponent />}
          </BlockWrapper>
        )}
      >
        {() => {
          return (
            <BlockWrapper index={index} style={style}>
              {children({data, refetch})}
            </BlockWrapper>
          );
        }}
      </Loading>
    </ErrorCatcher>
  );
};

export default ProjectDetailsBlockWrapper;
